module.exports = __webpack_public_path__ + "img/winter-tidings-thumbnail.e4b59c51.jpg";